const editElem = (selector, property, value) => {
  if (document.querySelector(selector)) {
      if (property !== "disabled")
        document.querySelector(selector).style[property] = value;
      else if (property === "disabled") 
          document.querySelector(selector).disabled = value;
  }
};

export { editElem as default };